import { connect, Dispatch } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';
import { searchDriveItems } from '../../DriveItemList/Search/actions';
import { SearchDriveItemState } from '../../DriveItemList/Search/reducer';

interface SearchDriveItemListPageProps extends AbstractDriveItemListPageProps {
	dispatch: Dispatch<StoreState>;
	search: SearchDriveItemState;
}

export class SearchDriveItemListPage extends AbstractDriveItemListPage<SearchDriveItemListPageProps> {

	headerLabel = 'messages.search';
	noItemsLabel = 'messages.no_results';

	initializeView(props: SearchDriveItemListPageProps): void {
		const { dispatch, params, search } = props;
		const { isFetching } = search;
		const newSearch = params.originParam || '';
		const oldSearch = search.searchString;

		if (!isFetching && newSearch !== oldSearch) {
			dispatch(searchDriveItems(newSearch));
		}
	}

	getDriveItemIds(): number[] {
		const { isFetching, driveItemIds} = this.props.search;
		return isFetching ? [] : driveItemIds;
	}

	isFetching(driveItemIds: number[]): boolean {
		return this.props.search.isFetching;
	}
}

const mapStateToProps = (state: StoreState) => {
	const { search } = state;
	return { search };
};

export default connect(mapStateToProps)(SearchDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/Search.tsx